module.exports = "/static/assets/ad93ad726651f5aa12f59233be08e436.png";